<div class="jumbotron text-center hero-background" role="img" aria-label="Dedicated support and online assistance">
  <i class="icon-support text-white"></i>
  <h2 class="text-white mt-4">Success driven support</h2>
  <p class="lead text-white">
    You’ll have a dedicated account manager with industry experience working hard for you throughout the entire process. Your success is our success.
  </p>
  <p class="lead">
    <button class="btn btn-primary btn-lg" (click)="openChat()" role="button">Get in touch</button>
  </p>
</div>
